import { Component, Input, OnInit } from '@angular/core';
import { MenuItem, Message, SelectItem } from 'primeng/api';

import { CommonDataService } from '../services/common-data.service';
import { WorkflowStatusRequest, OnboardStatus } from './workflow-status';
import { WorkflowStatusDataService } from './workflow-status-data.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-workflow-status',
  templateUrl: './workflow-status.component.html',
  styleUrls: ['./workflow-status.component.css'],
  providers: [WorkflowStatusDataService]
})
export class WorkflowStatusComponent implements OnInit {

  workflowSteps: MenuItem[] = [];
  workflowIndex: number;
  workflowIndexSaved: number;
  routeTo: string;
  interactive: boolean = false;

  onboardStatus: OnboardStatus;

  private _request: WorkflowStatusRequest;
  @Input()
  set request(value: WorkflowStatusRequest) {
    if (value) {
      console.log('workflow-status:set request =' + value);
      this._request = value;
      this.getWorkflowStatus(value);
    } else {
      console.log('workflow-status:set request = undefind value');
    }
  }

  get request(): WorkflowStatusRequest {
    return this._request;
  }

  constructor (private commonDataService: CommonDataService, private dataService: WorkflowStatusDataService, private router: Router) { }

  ngOnInit() {
  }

  getWorkflowStatus(request: WorkflowStatusRequest) {

    switch (request.processType) {
      case 'onboard': {
        this.interactive = request.interactive;
        this.getOnboardWorkflowStatus(request);
        break;
      }
      default: {
        break;
      }
    }
  }

  getOnboardWorkflowStatus(request: WorkflowStatusRequest) {

    // define the workflow steps
    this.workflowSteps = [
      { label: 'Candidate Selection', command: (onClick) => { this.processOnboardStepClick(); } },
      { label: 'Employment Application', command: (onClick) => { this.processOnboardStepClick(); } },
      { label: 'Offer Letter', command: (onClick) => { this.processOnboardStepClick(); } },
      { label: 'Onboard Documents', command: (onClick) => { this.processOnboardStepClick(); } },
      { label: 'Virtual Orientation', command: (onClick) => { this.processOnboardStepClick(); } },
    ];

    this.onboardStatus = new OnboardStatus();
    this.dataService.getJobReq(request.jobReqId).subscribe(res => {
      this.onboardStatus.currentStatus = res.currentStatus;
      this.onboardStatus.position = res.postedJobTitle;
      this.onboardStatus.hiringManagerId = res.hiringManagerId;

      this.commonDataService.getUserById(this.onboardStatus.hiringManagerId).subscribe(res => {
        this.onboardStatus.hiringManagerName = res.fullName;
      });

      console.log(`onboardStatus.currentStatus = ${this.onboardStatus.currentStatus}`);
      switch (this.onboardStatus.currentStatus) {
        case 'WAITING_FOR_EMPLOYMENT_APP': {
          this.workflowIndex = 1;
          this.routeTo = `employment-application/:${request.jobReqId}:${request.candidateId}:`;
          console.log(`constructed routeTo = ${this.routeTo}`);
          break;
        }
        case 'WAITING_FOR_SIGNED_OFFER_LETTER': {
          this.workflowIndex = 2;
          break;
        }
        case 'WAITING_FOR_ONBOARDING_ACKS': {
          this.workflowIndex = 3;
          break;
        }
        case 'ONBOARDING_COMPLETE': {
          this.workflowIndex = 4;
          break;
        }
        default: {
          this.workflowIndex = 0;
          break;
        }
      }
      this.workflowIndexSaved = this.workflowIndex;
    });
    this.onboardStatus.candidateId = request.candidateId;

    this.dataService.getDueDate(request.jobReqId, request.candidateId).subscribe(res => {
      this.onboardStatus.dueDate = res.dueDate;
      this.onboardStatus.candidateName = res.firstName + " " + res.lastName;
    });

    this.onboardStatus.candidateName = 'Jin Chun';
  }

  processOnboardStepClick() {

    if (this.workflowIndex === this.workflowIndexSaved) {
      console.log('routing to ' + this.routeTo);
      this.router.navigate([this.routeTo]);
    }
    this.workflowIndex = this.workflowIndexSaved;
  }
}
